import React from 'react';
import {images} from '../../constants';

import './AboutUs.css';

const AboutUs = () => (
  <div className='app__aboutus app__bg flex__center section__padding' id='about'>
    <div className='app__aboutus-overlay flex__center'>
    </div>

    <div className='app__aboutus-content flex__center'>
      <div className='app__aboutus-content_about'>
        <h1 className='headtext__Cormorant'>About Us</h1>
      <p className='p__opensans'>
      
      We believe that collaboration and communication are the basis of our success. 
      That the needs and vision of our clients, and the unique direction of each project, 
      matter more than showcasing our particular style. 
      That strong communities are enhanced by spaces that are beautiful, functional, and welcoming..
      We understand that customer service is first and foremost, it is in our mission and our daily routine.
       Treating clients and people in general how they deserve to be treated is how we work at Juadebfm Designs.
      
      </p>
    </div>

    <div className='app__aboutus-content_knife flex__center'>
      <img src={images.knife} alt='about_knife'/>
    </div>

    <div className='app__aboutus-content_history'>
        <h1 className='headtext__Cormorant'>Our History</h1>
      <p className='p__opensans'>Founded in 2021, Juadebfm Design is a 
      full-service web development and brand design group located in Lagos, 
      Nigeria. As we’ve grown from a team of 1 to 6, we’ve also grown our capabilities to 
      meet our clients’ needs—from user experience design and wireframing, to design and development, 
      to marketing and management. We combine old-fashioned conversation with cutting-edge technology to ensure 
      we’re delivering your vision every step of the way.
      </p>
    </div>
  </div>
  </div>
);

export default AboutUs;
